<template>
  <v-container v-editable="blok" fluid fill-height class="ma-0 pa-0">
    <template v-for="item in blok.body">
      <component :key="item._uid" :blok="item" :is="item.component"></component>
    </template>
  </v-container>
</template>

<script>
export default {
  props: ['blok']
}
</script>